/* src/app/self-enrollment/pdf/terms/termsPdf.component.css */
* {
  margin: 0;
  padding: 0;
  text-indent: 0;
}
h2 {
  color: black;
  font-family: Calibri, sans-serif;
  font-style: normal;
  font-weight: bold;
  text-decoration: none;
  font-size: 18pt;
}
.p,
p {
  color: black;
  font-family: Calibri, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 11pt;
  margin: 0pt;
}
h3 {
  color: black;
  font-family: Calibri, sans-serif;
  font-style: normal;
  font-weight: bold;
  text-decoration: none;
  font-size: 14pt;
}
.h4,
h4 {
  color: black;
  font-family: Calibri, sans-serif;
  font-style: normal;
  font-weight: bold;
  text-decoration: none;
  font-size: 11pt;
}
.s1 {
  color: black;
  font-family: Calibri, sans-serif;
  font-style: normal;
  font-weight: bold;
  text-decoration: none;
  font-size: 11pt;
}
.s2 {
  color: black;
  font-family: Calibri, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 11pt;
}
.s3 {
  color: black;
  font-family: Calibri, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 7pt;
  vertical-align: 3pt;
}
.s4 {
  color: black;
  font-family: Calibri, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 6.5pt;
  vertical-align: 3pt;
}
.s5 {
  color: black;
  font-family: Calibri, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 10pt;
}
.a,
a {
  color: black;
  font-family: Calibri, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 11pt;
}
.s6 {
  color: black;
  font-family: Calibri, sans-serif;
  font-style: italic;
  font-weight: bold;
  text-decoration: none;
  font-size: 11pt;
}
.s8 {
  color: black;
  font-family: Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 8pt;
}
h1 {
  color: black;
  font-family: "Times New Roman", serif;
  font-style: normal;
  font-weight: bold;
  text-decoration: none;
  font-size: 20pt;
}
.s10 {
  color: black;
  font-family: "Times New Roman", serif;
  font-style: normal;
  font-weight: bold;
  text-decoration: none;
  font-size: 13pt;
  vertical-align: 6pt;
}
.s11 {
  color: black;
  font-family: "Times New Roman", serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 11pt;
}
.s12 {
  color: black;
  font-family: "Times New Roman", serif;
  font-style: italic;
  font-weight: normal;
  text-decoration: none;
  font-size: 11pt;
}
.s13 {
  color: #FFF;
  font-family: "Times New Roman", serif;
  font-style: normal;
  font-weight: bold;
  text-decoration: none;
  font-size: 11pt;
}
.s14 {
  color: black;
  font-family: "Times New Roman", serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 11pt;
}
.s15 {
  color: black;
  font-family: "Times New Roman", serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 11pt;
}
.s16 {
  color: black;
  font-family: "Times New Roman", serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 11pt;
}
.s17 {
  color: black;
  font-family: "Times New Roman", serif;
  font-style: normal;
  font-weight: bold;
  text-decoration: none;
  font-size: 11pt;
}
li {
  display: block;
}
#l1 {
  padding-left: 0pt;
  counter-reset: c1 1;
}
#l1 > li > *:first-child:before {
  counter-increment: c1;
  content: counter(c1, decimal) ". ";
  color: black;
  font-family: Calibri, sans-serif;
  font-style: normal;
  font-weight: bold;
  text-decoration: none;
  font-size: 11pt;
}
#l1 > li:first-child > *:first-child:before {
  counter-increment: c1 0;
}
#l2 {
  padding-left: 0pt;
  counter-reset: d1 1;
}
#l2 > li > *:first-child:before {
  counter-increment: d1;
  content: counter(d1, upper-latin) ". ";
  color: black;
  font-family: Calibri, sans-serif;
  font-style: normal;
  font-weight: bold;
  text-decoration: none;
  font-size: 11pt;
}
#l2 > li:first-child > *:first-child:before {
  counter-increment: d1 0;
}
#l3 {
  padding-left: 0pt;
}
#l3 > li > *:first-child:before {
  content: "\f0b7  ";
  color: black;
  font-family: Symbol, serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 11pt;
}
#l4 {
  padding-left: 0pt;
  counter-reset: e1 1;
}
#l4 > li > *:first-child:before {
  counter-increment: e1;
  content: counter(e1, lower-roman) ". ";
  color: black;
  font-family: Calibri, sans-serif;
  font-style: normal;
  font-weight: bold;
  text-decoration: none;
  font-size: 11pt;
}
#l4 > li:first-child > *:first-child:before {
  counter-increment: e1 0;
}
#l5 {
  padding-left: 0pt;
}
#l5 > li > *:first-child:before {
  content: "\25cf  ";
  color: black;
  font-family: Calibri, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 11pt;
}
#l6 {
  padding-left: 0pt;
  counter-reset: c2 1;
}
#l6 > li > *:first-child:before {
  counter-increment: c2;
  content: counter(c2, upper-latin) ". ";
  color: black;
  font-family: Calibri, sans-serif;
  font-style: normal;
  font-weight: bold;
  text-decoration: none;
  font-size: 11pt;
}
#l6 > li:first-child > *:first-child:before {
  counter-increment: c2 0;
}
#l7 {
  padding-left: 0pt;
}
#l7 > li > *:first-child:before {
  content: "\f0b7  ";
  color: black;
  font-family: Symbol, serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 11pt;
}
#l8 {
  padding-left: 0pt;
  counter-reset: h1 1;
}
#l8 > li > *:first-child:before {
  counter-increment: h1;
  content: counter(h1, upper-latin) ". ";
  color: black;
  font-family: Calibri, sans-serif;
  font-style: normal;
  font-weight: bold;
  text-decoration: none;
  font-size: 11pt;
}
#l8 > li:first-child > *:first-child:before {
  counter-increment: h1 0;
}
#l9 {
  padding-left: 0pt;
}
#l9 > li > *:first-child:before {
  content: "\f0b7  ";
  color: black;
  font-family: Symbol, serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 11pt;
}
#l10 {
  padding-left: 0pt;
}
#l10 > li > *:first-child:before {
  content: "\f0b7  ";
  color: black;
  font-family: Symbol, serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 11pt;
}
#l11 {
  padding-left: 0pt;
}
#l11 > li > *:first-child:before {
  content: "\f0b7  ";
  color: black;
  font-family: Symbol, serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 11pt;
}
#l12 {
  padding-left: 0pt;
}
#l12 > li > *:first-child:before {
  content: "\f0b7  ";
  color: black;
  font-family: Symbol, serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 11pt;
}
#l13 {
  padding-left: 0pt;
  counter-reset: c2 1;
}
#l13 > li > *:first-child:before {
  counter-increment: c2;
  content: counter(c2, upper-latin) ". ";
  color: black;
  font-family: Calibri, sans-serif;
  font-style: normal;
  font-weight: bold;
  text-decoration: none;
  font-size: 11pt;
}
#l13 > li:first-child > *:first-child:before {
  counter-increment: c2 0;
}
li {
  display: block;
}
#l14 {
  padding-left: 0pt;
  counter-reset: m1 1;
}
#l14 > li > *:first-child:before {
  counter-increment: m1;
  content: counter(m1, decimal) ". ";
  color: black;
  font-family: Calibri, sans-serif;
  font-style: normal;
  font-weight: bold;
  text-decoration: none;
  font-size: 11pt;
}
#l14 > li:first-child > *:first-child:before {
  counter-increment: m1 0;
}
#l15 {
  padding-left: 0pt;
  counter-reset: m2 1;
}
#l15 > li > *:first-child:before {
  counter-increment: m2;
  content: counter(m2, upper-latin) ". ";
  color: black;
  font-family: Calibri, sans-serif;
  font-style: normal;
  font-weight: bold;
  text-decoration: none;
  font-size: 11pt;
}
#l15 > li:first-child > *:first-child:before {
  counter-increment: m2 0;
}
#l16 {
  padding-left: 0pt;
}
#l16 > li > *:first-child:before {
  content: "\f0b7  ";
  color: black;
  font-family: Symbol, serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 11pt;
}
#l17 {
  padding-left: 0pt;
}
#l17 > li > *:first-child:before {
  content: "\f0b7  ";
  color: black;
  font-family: Symbol, serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 11pt;
}
#l18 {
  padding-left: 0pt;
}
#l18 > li > *:first-child:before {
  content: "\f0b7  ";
  color: black;
  font-family: Symbol, serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 11pt;
}
#l19 {
  padding-left: 0pt;
}
#l19 > li > *:first-child:before {
  content: "\f0b7  ";
  color: black;
  font-family: Symbol, serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 11pt;
}
#l20 {
  padding-left: 0pt;
}
#l20 > li > *:first-child:before {
  content: "\f0b7  ";
  color: black;
  font-family: Symbol, serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 11pt;
}
#l21 {
  padding-left: 0pt;
  counter-reset: m2 1;
}
#l21 > li > *:first-child:before {
  counter-increment: m2;
  content: counter(m2, upper-latin) ". ";
  color: black;
  font-family: Calibri, sans-serif;
  font-style: normal;
  font-weight: bold;
  text-decoration: none;
  font-size: 11pt;
}
#l21 > li:first-child > *:first-child:before {
  counter-increment: m2 0;
}
table,
tbody {
  vertical-align: top;
  overflow: visible;
}
@media (max-width: 767px) {
  img {
    width: 25vw;
  }
}
/*# sourceMappingURL=termsPdf.component.css.map */
